import { HStack, ModalCloseButton, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@/components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { dropDownFormStyle } from 'components/forms/new/formStyles';
import useAssignRegistrar from '../queries/useAssignRegistrar';

const AddAssignmentModal = ({
    isOpen,
    onClose,
    registrarId,
    companies,
    isLoading: companiesLoading,
    isFetching,
    onSuccess,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    const { restError } = useSelector((state) => state.modal);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [isHovered, setIsHovered] = useState(false);

    const handleAssignSuccess = () => {
        toast.success('Registrar assigned successfully!');
        setSelectedCompany(null);
        onSuccess();
    };

    const handleAssignError = (error) => {
        console.error('Failed to assign registrar:', error);
        toast.error(
            restError ?? 'Failed to assign registrar. Please try again.',
        );
    };

    const { mutate: assignRegistrar, isPending } = useAssignRegistrar(
        handleAssignSuccess,
        handleAssignError,
    );

    const handleSave = () => {
        if (!selectedCompany) {
            toast.error('Please select a company to assign.');
            return;
        }

        assignRegistrar({
            registrarId,
            companyId: selectedCompany?.id,
        });
    };

    const handleClose = () => {
        setSelectedCompany(null);
        onClose();
    };

    const isFormValid = selectedCompany?.id !== '';
    const isLoading = isPending || companiesLoading || isFetching;

    return (
        <Modal isOpen={isOpen} isCentered onClose={handleClose} size="xl">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent>
                <ModalHeader>Add New Assignment</ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    <HStack
                        align="start"
                        spacing={2}
                        pr={5}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}>
                        <HStack w="100%">
                            <Text
                                fontWeight="medium"
                                minW="164px"
                                fontSize="sm">
                                Assign to company{' '}
                                <span
                                    style={{
                                        color: 'var(--chakra-colors-red-500)',
                                    }}>
                                    *
                                </span>
                            </Text>

                            <VStack width="100%" alignItems="normal">
                                <Select
                                    tabSelectsValue
                                    openMenuOnFocus
                                    placeholder="Select company"
                                    value={selectedCompany}
                                    options={companies}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    onChange={(e) => {
                                        setSelectedCompany(e);
                                    }}
                                    selectedOptionColor="brand"
                                />
                            </VStack>
                        </HStack>
                        {isHovered && (
                            <FieldToolTip
                                label="Create an uneditable duplicate of the Registrar to the Company"
                                ariaLabel="registrar-tip"
                                left="25px"
                                top="10px"
                            />
                        )}
                    </HStack>
                </ModalBody>

                <ModalFooter>
                    <HStack spacing={3}>
                        <Button
                            variant="outline"
                            onClick={handleClose}
                            isDisabled={isLoading}>
                            Cancel
                        </Button>
                        <Button
                            w="86px"
                            onClick={handleSave}
                            isLoading={isLoading}
                            isDisabled={!isFormValid}>
                            Save
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AddAssignmentModal;
